export const advisors = [
  {
    name: "Andrei Oprisan",
    title: "Entrepreneur | CTO",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/andrei.jpeg",
    expertise: "MIT | Agent AI",
    linkedin: "https://www.linkedin.com/in/andreioprisan/",
  },
  {
    name: "Maria Tkacheva",
    title: "Entrepreneur | COO",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/maria.jpeg",
    expertise: "MIT | Seneca Polytechnic",
    linkedin: "https://www.linkedin.com/in/mariatkacheva/",
  },
  {
    name: "Michael A. Celone",
    title: "Attorney | Regulatory Strategy",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/michael.jpeg",
    expertise: "MIT | Harvard Law School",
    linkedin: "https://www.linkedin.com/in/michael-a-celone",
  },
  {
    name: "Tushar Kumar",
    title: "Oncologist | Entrepreneur",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/tushar.jpeg",
    expertise: "MIT | Wayne University School of Medicine",
    linkedin: "https://www.linkedin.com/in/tushar-kumar-md-mba-674a78253/",
  },
  {
    name: "Kyle Watson",
    title: "Cybersecurity Leader | Entrepreneur",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/kyle.jpeg",
    expertise: "Rochester Institute  of Technology",
    linkedin: "https://www.linkedin.com/in/tokylewatson/",
  },
  {
    name: "Shiro Matsuzaki",
    title: "Founder | Serial Intrapreneur",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/shiro.jpeg",
    expertise: "MIT | Waseda University",
    linkedin: "https://www.linkedin.com/in/shiro-matsuzaki-184a52192/",
  },
  {
    name: "Ayo Okeowo",
    title: "Cybersecurity Leader",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/ayo.jpeg",
    expertise: "MIT | University of Oxford",
    linkedin: "https://www.linkedin.com/in/okeowo/",
  },
  {
    name: "Steven Smith",
    title: "General Counsel | COO",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/steven.jpeg",
    expertise: "MIT | Boston College Law School",
    linkedin: "https://www.linkedin.com/in/steven-smith-331b0811/",
  },
  {
    name: "Chris Kenny, MD",
    title: "Chief Medical Officer",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/chris.jpeg",
    expertise: "MIT | Boston University School of Medicine",
    linkedin: "https://www.linkedin.com/in/chris-kenney-md-mba-faan-867751a/",
  },
];
